<div class="container-page" id="container-page">
  <router-outlet></router-outlet>
  <flash-messages></flash-messages>
  <app-confirm></app-confirm>
</div>
